/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";
import React from "react";
import Icon from "../elements/icon";

export default class ModalHeaderDeprecated extends React.Component {
  static displayName = "ModalHeaderDeprecated";

  static propTypes = {
    header: PropTypes.any,
    allowClose: PropTypes.bool,
    closeModal: PropTypes.func,
    onCancel: PropTypes.func,
  };

  static defaultProps = { allowClose: true };

  handleCancel = () => {
    if (!this.props.disableCancel) {
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel();
      }
      return typeof this.props.closeModal === "function" ? this.props.closeModal() : undefined;
    }
  };

  render() {
    return (
      <div className={`et--modal-header ${this.props.className || ""}`}>
        {/* not sure why this div is here but didn't want to break some layout relying on it */}
        <div className="et--modal-header--inner">
          {typeof this.props.header === "string" ? <h3>{this.props.header}</h3> : this.props.header}
          {this.props.allowClose ? (
            <Icon className="et--modal-header--close" icon="close" onClick={this.handleCancel} />
          ) : undefined}
        </div>
      </div>
    );
  }
}
